module.exports = __webpack_public_path__ + "static/media/logo_universidade_christus_invertido.9fea0876.png";